module.exports = __webpack_public_path__ + "static/img/case6.4e339cf.jpg";